<template>
  <div class="t-lk-container">
    <div v-animation:bottom.delay class="t-lk-title-link t-lk-container-mobile t-lk-materials__title">
      <h1 class="t-lk-title t-lk-title-link__title">{{ $root.staticText.lk.materialsVendorsTitle }}</h1>
      <router-link
        class="t-btn-green t-lk-materials__btn"
        :class="{ _active: $route.query.favorite }"
        :to="{
          name: $route.name,
          query: {
            ...$route.query,
            favorite: $route.query.favorite ? undefined : true,
            currentPage: undefined,
          },
        }"
      >
        {{ $route.query.favorite ? $root.staticText.lk.materialsAll : $root.staticText.lk.materialsFavorite }}
      </router-link>
    </div>

    <div v-animation:bottom.delay class="t-lk-materials__filter">
      <filter-cmp
        v-if="filter"
        :filter="filter"
        :name-btn="$root.staticText.lk.materialsFilterBtn"
        :obj-undefined="{ currentPage: undefined }"
        :white="true"
        :is-date="true"
        :is-date-left="false"
      >
      </filter-cmp>
    </div>

    <div class="t-lk-materials__container js-materials-vendors">
      <router-link
        v-animation:bottom.delay
        v-for="(item, idx) in materials"
        :key="`materials-item-${item.id}-${idx}`"
        :to="item.link"
        class="t-lk-materials__item"
      >
        <div class="t-lk-materials__img">
          <img v-if="item.img" :src="item.img" :alt="item.name" />
        </div>
        <div class="t-lk-materials__row">
          <div class="t-lk-materials__name">{{ item.name }}</div>
          <div class="t-lk-materials__favorite" :class="{ _active: item.isFavorites }" @click.stop.prevent="toggleFavorite(item)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0002 1.2002C12.3047 1.2002 12.5828 1.37305 12.7176 1.6461L15.6216 7.52937L22.1159 8.47861C22.4172 8.52264 22.6673 8.73384 22.7612 9.02345C22.8551 9.31306 22.7765 9.63086 22.5584 9.84328L17.8598 14.4197L18.9687 20.885C19.0202 21.1851 18.8968 21.4885 18.6504 21.6674C18.404 21.8464 18.0774 21.87 17.8079 21.7283L12.0002 18.6741L6.19258 21.7283C5.92305 21.87 5.59641 21.8464 5.35003 21.6674C5.10365 21.4885 4.98025 21.1851 5.03173 20.885L6.1406 14.4197L1.44203 9.84328C1.22394 9.63086 1.14532 9.31306 1.23922 9.02345C1.33312 8.73384 1.58327 8.52264 1.88452 8.47861L8.37881 7.52937L11.2829 1.6461C11.4176 1.37305 11.6957 1.2002 12.0002 1.2002Z"
                stroke="#C0C0CC"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="t-lk-materials__bottom">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.66634 5.83333V12.5C6.66634 12.942 6.84194 13.366 7.1545 13.6785C7.46706 13.9911 7.89098 14.1667 8.33301 14.1667H13.333M6.66634 5.83333V4.16667C6.66634 3.72464 6.84194 3.30072 7.1545 2.98816C7.46706 2.67559 7.89098 2.5 8.33301 2.5H12.1547C12.3757 2.50005 12.5876 2.58788 12.7438 2.74417L16.4222 6.4225C16.5785 6.57874 16.6663 6.79067 16.6663 7.01167V12.5C16.6663 12.942 16.4907 13.366 16.1782 13.6785C15.8656 13.9911 15.4417 14.1667 14.9997 14.1667H13.333M6.66634 5.83333H4.99967C4.55765 5.83333 4.13372 6.00893 3.82116 6.32149C3.5086 6.63405 3.33301 7.05797 3.33301 7.5V15.8333C3.33301 16.2754 3.5086 16.6993 3.82116 17.0118C4.13372 17.3244 4.55765 17.5 4.99967 17.5H11.6663C12.1084 17.5 12.5323 17.3244 12.8449 17.0118C13.1574 16.6993 13.333 16.2754 13.333 15.8333V14.1667"
              stroke="#C0C0CC"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>{{ item.count }}</span>
        </div>
      </router-link>
    </div>
    <pagination-cmp v-animation:bottom.delay v-if="pagination" :pagination="pagination" :name-current-page="'currentPage'" class="_lk">
    </pagination-cmp>
  </div>
</template>

<script>
import Vue from 'vue'
import filter from '@components/lk/lk-filter/lk-filter'
import pagination from '@ui/pagination/pagination'
import { observeNewAnimateBlocks } from '@shared/utils/animate/scroll.animate'

export default {
  name: 'materials-vendors',
  data() {
    return {
      filter: null,
      materials: [],
      pagination: null,
    }
  },
  components: {
    'filter-cmp': filter,
    'pagination-cmp': pagination,
  },
  methods: {
    setData(data) {
      this.filter = data.filter
      this.materials = data.materials
      this.pagination = data.pagination
    },
    toggleFavorite(item) {
      let url = 'lk/materials-vendors/addFavorite'

      if (item.isFavorites) {
        url = 'lk/materials-vendors/removeFavorite'
      }

      let fd = new FormData()
      fd.append('id', item.id)

      Vue.http
        .post(url, fd)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            item.isFavorites = !item.isFavorites
          }
        })
        .catch(() => {})
    },
  },
  beforeRouteUpdate(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/materialsVendors.json' : 'lk/materials-vendors'

    this.$root.setDataAnimateFalse('.js-materials-vendors ')

    Vue.http.get(url, { params: to.query }).then(
      data => {
        this.setData(data.data)
        next()
        this.$nextTick(() => {
          observeNewAnimateBlocks()
        })
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/materialsVendors.json' : 'lk/materials-vendors'
    Vue.http.get(url).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/materials/materials-vendors/index.vue